import { TitleCasePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import * as moment from "moment";
import {
  ConfirmationService,
  LazyLoadEvent,
  MessageService,
} from "primeng/api";
import { Table } from "primeng/table";
import { ScheduleService } from "src/app/services/schedule.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { environment } from "src/environments/environment";
import { Router } from '@angular/router';

@Component({
  selector: "app-profilerequest",
  templateUrl: "./profilerequest.component.html",
  styleUrls: ["./profilerequest.component.scss"],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})
export class ProfilerequestComponent implements OnInit {
  userList: any;
  opponentUserList: any;
  activeIndex: any;
  totalRecords: 0;
  totalOpponentRecords: 0;
  loading: boolean;
  paginationOption;
  errormessage = "";
  downloadFlg: boolean;
  searchby;
  searchbyOpponent;
  startDate: Date;
  endDate: Date;
  startDateOpponent: Date;
  endDateOpponent: Date;
  searchBy: any[];
  searchByStatus: any[];
  searchbystatus;
  selectedValue: string;
  public loggedInUser;
  public isLoggedIn: boolean = false;
  public userId;
  hideStatus: boolean = false;
  selectedStartDateRange: Date[];
  selectedStartDateRangeOpponent: Date[];

  public showingSentRequest: boolean = false;

  @ViewChild("dt", { static: false }) public dt: Table;

  private lastTableLazyLoadEvent: LazyLoadEvent;

  constructor(
    private scheduleservice: ScheduleService,
    private confirmationservice: ConfirmationService,
    private titlecasePipe: TitleCasePipe,
    private messageService: MessageService,
    private tokenStorage: TokenStorageService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.searchby = { label: "", value: "", status: "" };
    this.searchbyOpponent = { label: "", value: "", status: "" };

    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
    }

    this.paginationOption = environment.pagination;
    this.downloadFlg = false;
    this.searchBy = [
      // { label: 'Pending', value: "created_at", status: 'Pending' },
      { label: "All", value: "", status: "" },
      { label: "Booked", value: "booked_at", status: "Booked" },
      { label: "Approved", value: "approved_at", status: "Approved" },
      { label: "Rejected", value: "rejected_at", status: "Rejected" },
      { label: "Cancelled", value: "rejected_at", status: "Cancelled" },
    ];
    this.searchByStatus = [
      { label: "All", value: "", status: "" },
      { label: "Pending", value: "booked_at", status: "Booked" },
      { label: "Approved", value: "approved_at", status: "Approved" },
      { label: "Rejected", value: "rejected_at", status: "Rejected" },
      { label: "Cancelled", value: "rejected_at", status: "Cancelled" },
    ];
  }

  loaduserList(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByUserId=" + this.userId;
    var pagenumber = 1;
    var params = "";
    var rows;

    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = "";
    }

    // at the time of download hide pagination option
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }

    if (
      (this.startDate != undefined && this.endDate != undefined)
    ) {
      let first;
      let second;
      if (this.startDate != undefined && this.endDate != undefined) {
        first = moment(this.startDate).format("YYYY-MM-DD");
        second = moment(this.endDate).format("YYYY-MM-DD");
        this.selectedStartDateRange = [first, second];
      }
      if (this.selectedStartDateRange != null) {
        query += "&filterByStartDateRange=" + this.selectedStartDateRange;
      }
      // params += "&filterByBookingStatus=" + this.searchby.status;
    } if (this.searchby.label === "All") {
      params += "&exceptPendingStatus=" + "Pending";
    
    }
    else if (this.searchby == "" || this.searchby.label == "") {
      params += "&exceptPendingStatus=" + "Pending";
    } else {
      params += "&filterByBookingStatus=" + this.searchby.status;
    }
    //   if(this.searchby != undefined){
    // params += "&filterByBookingStatus=" + this.searchby.value
    //   }

    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    //want passed cancelled schedule which is booked so removing where opponent is not booked user schdule by passing this flag as trye
    query +="&filterByOpponent=true"
    this.scheduleservice.getScheduleList(query).subscribe(
      (res) => {
        window.scroll(0, 0);
        this.userList = res.data.items;
        this.totalRecords = res.data.totalCount;
      },
      (err) => {
        this.errormessage = err.error.message;
      }
    );

    if (this.searchby.label === "Booked") {
      this.hideStatus = true;
    } else {
      this.hideStatus = false;
    }
  }

  approveuser(user) {
    this.confirmationservice.confirm({
      message:
        "Are you sure to approve " +
        this.titlecasePipe.transform(user.opponentUserName) +
        "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        var disableStatus;
        if (user.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }

        var userStatus = '{"Approved":' + disableStatus + "}";
        this.scheduleservice.updatestatus(user.id, userStatus).subscribe(
          (data) => {
            this.messageService.add({
              key: "toastmsg",
              severity: "success",
              summary: "Successful",
              detail: "User Status Updated",
              life: 3000,
            });
            this.loaduserList(this.lastTableLazyLoadEvent);
          },
          (err) => {
            this.errormessage = err.error.message;
          }
        );
      },
      reject: () => { },
    });
  }

  rejectuser(user) {
    this.confirmationservice.confirm({
      message:
        "Are you sure to reject " +
        this.titlecasePipe.transform(user.opponentUserName) +
        "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        var disableStatus;
        if (user.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }

        // bookingStatus:'Approved'
        var userStatus = '{"Rejected":' + disableStatus + "}";
        this.scheduleservice.updatestatus(user.id, userStatus).subscribe(
          (data) => {
            this.messageService.add({
              key: "toastmsg",
              severity: "success",
              summary: "Successful",
              detail: "User Rejected",
              life: 3000,
            });
            this.loaduserList(this.lastTableLazyLoadEvent);
          },
          (err) => {
            this.errormessage = err.error.message;
          }
        );
      },
      reject: () => { },
    });
  }
  cancelBooking(user) {
    // console.log("ghihli",event)
    this.confirmationservice.confirm({
      message:
      "Are you sure to  cancel Booking " +
      // this.titlecasePipe.transform(user.opponentUserName) +
      "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        var disableStatus;
        if (user.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }

        // bookingStatus:'Approved'
        var userStatus = '{"cancel":' + disableStatus + "}";
        this.scheduleservice.updatestatus(user.id, userStatus).subscribe(
          (data) => {
            this.messageService.add({
              key: "toastmsg",
              severity: "success",
              summary: "Successful",
              detail: "Booking Cancelled",
              life: 3000,
            });
            this.loaduserSentRequestList(this.lastTableLazyLoadEvent);
            setTimeout(() => {
              let currentUrl = this.router.url;
              this.router.routeReuseStrategy.shouldReuseRoute = () => false;
              this.router.onSameUrlNavigation = 'reload';
              this.router.navigate([currentUrl]);
            }, 3000);
          },
          (err) => {
            this.errormessage = err.error.message;
          }
        );
      },
      reject: () => { },
    });
  }
  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.selectedStartDateRange = [];
    this.loaduserList(this.lastTableLazyLoadEvent);
  }
  openmodal() {
    this.showingSentRequest = false;
    this.activeIndex = 0;
    alert('test1')
  }
  onCloseModal() {
    this.showingSentRequest = false;
    this.activeIndex = 1;
    alert('test2')
  }

  loaduserSentRequestList(event: LazyLoadEvent) {
    // this.userList = null;
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByOpponentUserId=" + this.userId;
    var pagenumber = 1;
    var params = "";
    var rows;

    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = "";
    }

    // at the time of download hide pagination option
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }

    if (

      this.startDateOpponent != undefined &&
      this.endDateOpponent != undefined
    ) {
      let first;
      let second;
      if (this.startDateOpponent != undefined && this.endDateOpponent != undefined) {
        first = moment(this.startDateOpponent).format("YYYY-MM-DD");
        second = moment(this.endDateOpponent).format("YYYY-MM-DD");
        this.selectedStartDateRangeOpponent = [first, second];
      }
      if (this.selectedStartDateRangeOpponent != null) {
        query += "&filterByStartDateRange=" + this.selectedStartDateRangeOpponent;
      }
      // params += "&filterByBookingStatus=" + this.searchby.status;
    }
    if (this.searchbyOpponent.label === "All") {
      params += "&exceptPendingStatus=" + "Pending";
    }
    else if (this.searchbyOpponent == "" || this.searchbyOpponent.label == "") {
      params += "&exceptPendingStatus=" + "Pending";
    } else {
      params += "&filterByBookingStatus=" + this.searchbyOpponent.status;
    }
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    this.scheduleservice.getScheduleList(query).subscribe(
      (res) => {
        window.scroll(0, 0);
        this.opponentUserList = res.data.items;
        this.totalOpponentRecords = res.data.totalCount;
      },
      (err) => {
        this.errormessage = err.error.message;
      }
    );

    if (this.searchbyOpponent.label === "Booked") {
      this.hideStatus = true;
    } else {
      this.hideStatus = false;
    }
  }
  clear2() {
    this.startDateOpponent = null;
    this.endDateOpponent = null;
    this.searchbyOpponent = "";
    this.selectedStartDateRangeOpponent = [];
    this.loaduserSentRequestList(this.lastTableLazyLoadEvent);
  }
  clearFilter() {
    this.clear();
    this.clear2();
  }

}
